<template>
  <div class="flex flex-col gap-[12px]">
    <h1 class="m-0 text-[24px] font-semibold leading-[32px]">
        {{ splitTitle(pageTitle)?.first }}
        <span :class="['text-lime-green ']">
        {{ splitTitle(pageTitle)?.last }}
        </span>
    </h1>

    <div v-if="subtitle" class="text-[16px] font-light text-medium-gray">
      {{ subtitle }}
    </div>

    <div class="w-full h-1 my-[16px] mb-[48px] border-b border-light-gray/25">
      <div class="w-[56%] md:w-[16%] h-1" :class="['bg-lime-green ']" />
    </div>
  </div>
  <section v-html="content"/>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  pageTitle: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: null,
  },
  content: {
    type: String,
    default: null,
  },
});
const splitTitle = (string) => {
  if (!string) return {};
  const words = string.split(" ");
  const last = words.pop();
  return {
    first: words.join(" "),
    last,
  };
};

</script>
